'use strict';

angular.module('amexReconciliationApp')
    .component('feedbackComponent', {
        templateUrl: 'scripts/views/components/feedback-component.html',
        controllerAs: 'feedbackComponentController',
        controller: function ($scope,
                              UserModel, $rootScope
        ) {
            var self = this;
            self.userLang = '';
            self.url = 'https://www.aexpfeedback.com/jfe/form/SV_5vwigOdCkkHKB2B';

            function updateSelectedUserLanguage() {
                self.userLang = UserModel.currentUserPreferences().language;
            }

            UserModel.onCurrentUserChanged($rootScope, updateSelectedUserLanguage);

            self.displayFeedbackButton = function displayFeedbackButton() {
                return (self.userLang === 'EN_US');
            };

            self.openFeedbackWindow = function () {
                window.open(self.url, 'Recon-Feedback', 'width=1000,height=1000,left=200,top=200');
            };
        }
    });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/feedbackComponent.js
// module id = 450
// module chunks = 0